import { render } from "./PoliticaPrivacidad.vue?vue&type=template&id=93f563d6&scoped=true"
import script from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"

import "./PoliticaPrivacidad.vue?vue&type=style&index=0&id=93f563d6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93f563d6"]])

export default __exports__